/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * Connect bank account delete connection.
 */

function connectBankAccountDeleteAccount(
  client: AxiosInstance,
  integrationId: string
): Promise<{ url: string; showLocalCredentials: boolean }> {
  return client({
    method: 'delete',
    url: resolveAppUrl('bankAccountConnectDeleteAccount', { interpolations: { integrationId } })
  }).then(({ data }) => {
    return data?.data;
  });
}

/**
 * Export `useBankAccountDeleteAccount`.
 */

export function useBankAccountDeleteAccount() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async ({ integrationId }: { integrationId: string }) => {
      const result = await connectBankAccountDeleteAccount(client, integrationId);

      return result;
    },
    onSuccess: () => {
      // Nothing to do.
    }
  });
}
